import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Secondary, Text } from "@cinch-labs/design-system";
import { VehicleCard as SharedVehicleCard } from "@cinch-nx/landing-ui-shared";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import SearchIcon from "../assets/search.svg";
import styles from "./cards.module.css";
export var FindSimilarVehiclesCard = function() {
    var trackEvent = useAnalytics().trackEvent;
    var sendTrackEvent = function() {
        trackEvent({
            eventName: "Browse all cars",
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: "click",
                    category: "recently-viewed",
                    label: "browse-all-cars",
                    action: "car-search-cta"
                }
            }
        });
    };
    return /*#__PURE__*/ _jsx("div", {
        className: styles["vehicleCardContainer"],
        children: /*#__PURE__*/ _jsxs("article", {
            className: styles["findSimilarVehiclesCard"],
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: styles["textContainer"],
                    children: [
                        /*#__PURE__*/ _jsx(SearchIcon, {}),
                        /*#__PURE__*/ _jsxs(Text, {
                            className: styles["text"],
                            fontWeight: "bold",
                            fontSize: "xl",
                            lineHeight: "display",
                            children: [
                                "Looking for something different?",
                                " "
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Secondary, {
                    element: "a",
                    variant: "alternative",
                    classNames: {
                        button: styles["button"]
                    },
                    href: "/used-cars",
                    onClick: function() {
                        return sendTrackEvent();
                    },
                    children: "Browse all cars"
                })
            ]
        })
    });
};
export var VehicleCard = function(param) {
    var vehicle = param.vehicle, carouselName = param.carouselName;
    var trackEvent = useAnalytics().trackEvent;
    var handleClick = function() {
        trackEvent({
            eventName: "".concat(carouselName, " - PDP Cards"),
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: carouselName,
                    label: vehicle.vehicleId,
                    action: "Open"
                }
            }
        });
    };
    return /*#__PURE__*/ _jsx("div", {
        className: styles["vehicleCardContainer"],
        children: /*#__PURE__*/ _jsx(SharedVehicleCard, {
            id: vehicle.vehicleId,
            isSaved: false,
            isPending: vehicle.isReserved,
            isAvailable: vehicle.isAvailable,
            vehicle: vehicle,
            isSmallCardSize: true,
            onCardClick: handleClick,
            isPersonalised: true
        }, vehicle.vehicleId)
    });
};
export var VehicleCardsList = function(param) {
    var vehicles = param.vehicles, carouselName = param.carouselName;
    return /*#__PURE__*/ _jsxs("ul", {
        className: styles["vehicleCardList"],
        "aria-label": carouselName,
        children: [
            vehicles.map(function(vehicle) {
                return /*#__PURE__*/ _jsx("li", {
                    children: /*#__PURE__*/ _jsx(VehicleCard, {
                        vehicle: vehicle,
                        carouselName: carouselName
                    }, vehicle.vehicleId)
                }, vehicle.vehicleId);
            }),
            vehicles.length <= 2 ? /*#__PURE__*/ _jsx("li", {
                className: styles["vehicleCardListItem"],
                children: /*#__PURE__*/ _jsx(FindSimilarVehiclesCard, {})
            }, "find-similar") : null
        ]
    });
};
